export const BID_PACKAGES_TAB = 1;
export const CONTRACT_DOCUMENTS_TAB = 4;
export const LEGACY_SCOPE_CHECKLISTS_TAB = 7;
export const SCOPE_GAP_ANALYSIS_TAB = 8;
export const QUOTE_REVIEW_TAB = 9;
export const MATERIAL_TRACKING_TAB = 12;
export const DRAWINGS_TAB = 11;

const VALID_PROJECT_TABS = new Set([
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	DRAWINGS_TAB,
	MATERIAL_TRACKING_TAB,
]);

export interface ProjectTabRoute {
	tab: number | null;
	redirectToBidPackages: boolean;
}

export const getProjectTabRoute = (search: string, bidInvitesEnabled = false): ProjectTabRoute => {
	const rawTab = new URLSearchParams(search).get('tab');
	if (
		bidInvitesEnabled &&
		(rawTab === 'scope-checklists' ||
			rawTab === '3' ||
			rawTab === String(LEGACY_SCOPE_CHECKLISTS_TAB))
	) {
		return { tab: BID_PACKAGES_TAB, redirectToBidPackages: true };
	}
	if (rawTab === 'scope-checklists') {
		return { tab: LEGACY_SCOPE_CHECKLISTS_TAB, redirectToBidPackages: false };
	}
	if (rawTab === 'scope-gap-analysis') {
		return { tab: SCOPE_GAP_ANALYSIS_TAB, redirectToBidPackages: false };
	}
	if (rawTab === 'quote-review') {
		return { tab: QUOTE_REVIEW_TAB, redirectToBidPackages: false };
	}
	if (rawTab === 'material-tracking') {
		return { tab: MATERIAL_TRACKING_TAB, redirectToBidPackages: false };
	}
	if (rawTab === 'drawings') {
		return { tab: DRAWINGS_TAB, redirectToBidPackages: false };
	}
	if (!/^\d+$/.test(rawTab || '') || /^0\d+/.test(rawTab || '')) {
		return { tab: null, redirectToBidPackages: false };
	}
	const numericTab = Number(rawTab);
	return {
		tab: VALID_PROJECT_TABS.has(numericTab) ? numericTab : null,
		redirectToBidPackages: false,
	};
};

export const getProjectTabFromSearch = (search: string, bidInvitesEnabled = false) =>
	getProjectTabRoute(search, bidInvitesEnabled).tab;
